















































// Importing components
import LayoutApp from '@/layputs/LayoutApp.vue';
import BaseButton from '@/ui/BaseButton.vue';
import BaseCard from '@/ui/BaseCard.vue';
import BaseAlertList from '@/ui/BaseAlertList.vue';
import BasePagination from '@/base/BasePagination.vue';
import BaseInputField from '@/ui/BaseInputField.vue';
import TheFormTowns from '@/components/restaurants/TheFormTowns.vue';
import TheTableTowns from '@/components/restaurants/TheTableTowns.vue';
// Importing function
import {postTown} from '@/ts/restaurants/post-restaurant';
import {getRestaurants} from '@/ts/restaurants/get-restaurants';
// Importing variables
import {MissingTown} from '@/ts/variables';

export default {
    name: 'PageTowns',
    components: {
        LayoutApp,
        BaseCard,
        BasePagination,
        TheTableTowns,
        TheFormTowns,
        BaseButton,
        BaseInputField,
        BaseAlertList,
    },
    props: {},
    data() {
        return {
            items: Array(),
            errors: Array(),
        };
    },
    methods: {
        handleSubmit(event) {
            this.errors = [];

            if (event.length === 0) { this.errors.push(MissingTown); }

            if (this.errors.length === 0) {
                this.$store.dispatch('setLoadingOn');
                postTown(event, this.$route.params.id).finally(() => {
                    this.$store.dispatch('setLoadingOff');
                });
            }
        },
    },
    created() {
        // Initializing the items object
        this.items = [{
            text: 'Панел',
            to: { path: '/dashboard' },
        }, {
            text: 'Ресторанти',
            to: { path: '/restaurants' },
        }, {
            text: 'Градове',
        }];

        this.$store.dispatch('setLoadingOn');
        getRestaurants().finally(() => {
            this.$store.dispatch('setLoadingOff');
        });
    },
};
